// extracted by mini-css-extract-plugin
export default {"modale":"AddTodoList_modale__jKWEQ","content":"AddTodoList_content__6cg5O"};